(function () {
    'use strict';

    angular.module('app').factory('LoyaltyService', LoyaltyService);

    LoyaltyService.$inject = ['$rootScope', '$location', 'API', 'NotifyService', 'localStorageService'];

    function LoyaltyService($rootScope, $location, API, NotifyService, localStorageService) {
        var service = {};
        /**
         * This callback type is called `requestCallback` and is displayed as a global symbol.
         *
         * @callback requestCallback
         * @param {boolean} success
         * @param {Object} data
         */
        /**
         * @typedef MultiLanguageObject
         * @type {Object}
         * @property {string} en - String on English
         * @property {string} pl - String on Polish
         * @property {string} ru - String on Russian
         * @property {string} uk - String on Ukrainian
         */
        initVars();

        function initVars() {
            $rootScope.RATE_RULES = {};
            $rootScope.DELIVERY_TYPES = {};
        }

        $rootScope.$on('user-login', function () {
            initVars();
        });

        $rootScope.$on('user-register', function () {
            initVars();
        });

        $rootScope.$on('user-logout', function () {
            $rootScope.LOYALTIES = null;
            $rootScope.RATE_RULES = null;
            $rootScope.LOYALTY_SETTINGS = null;
            $rootScope.LOYALTY_REFERRAL_PROGRAM = null;
            $rootScope.LOYALTY_ONLINE_STORE = null;
            $rootScope.DELIVERY_TYPES = null;
        });

        // =========================================  MAIN LOYALTY  ====================================================

        /**
         * Get list of all loyalties
         */
        service.All = function (callback) {
            API.get('/loyalty', function (success, data) {
                if (success) {
                    $rootScope.LOYALTIES = data;
                }
                callback(success, data);
            });
        };

        /**
         * Get loyalty info
         */
        service.Get = function (id, callback) {
            API.get('/loyalty/' + id, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.LOYALTIES, data);
                }
                callback(success, data);
            });
        };

        /**
         * Get Categories for news list
         */
        service.LoyaltyCategories = function (callback) {
            if (!$rootScope.LOYALTY_CATEGORIES)
                $rootScope.LOYALTY_CATEGORIES = [];

            API.get('/settings/categories', function (success, data) {
                if (success) {
                    $rootScope.LOYALTY_CATEGORIES[$rootScope.LANG] = data;
                }
                callback(success, data);
            });

        };

        /**
         * Create new loyalty
         */
        service.Create = function (post_data, callback) {
            API.post('/loyalty', post_data, function (success, data) {
                if (success) {
                    NotifyService.Success(data.message, false);
                }
                callback(success, data);
            });
        };

        /**
         * Change loyalty
         */
        service.Change = function (id, post_data, callback) {
            API.patch('/loyalty/' + id, post_data, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.LOYALTIES, data);
                    if (!$location.$$search && !$location.$$search.tab) {
                        NotifyService.Success(data.message, false);
                    }
                }
                callback(success, data);
            });
        };

        /**
         * Upload photo
         * @param loyaltyID - Loyalty ID
         * @param data
         * @param {requestCallback} callback - The callback that handles the response.
         *
         */
        service.UploadPhoto = function (loyaltyID, data, callback) {
            API.postImage('/loyalty/' + loyaltyID + '/photo', data, function (success, response) {
                callback(success, response);
            });
        };

        /**
         * Delete/Clear loyalty photo.
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeletePhoto = function (loyaltyID, callback) {
            API.delete('/loyalty/' + loyaltyID + '/photo', null, function (success, response) {
                callback(success, response);
            });
        };

        // =========================================  Card Categories  =================================================
        /**
         * Get card categories list.
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CardCategories = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/card_categories', function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryId
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCardCategories = function (loyaltyID, categoryId, callback) {
            API.get('/loyalty/' + loyaltyID + '/card_categories/' + categoryId, function (success, data) {
                callback(success, data);
            });
        };
        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param dataPost
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddCardCategories = function (loyaltyID, dataPost, callback) {
            API.post('/loyalty/' + loyaltyID + '/card_categories', dataPost, function (success, data) {
                callback(success, data);
            });
        };
        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryId
         * @param dataPost
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.SaveCardCategories = function (loyaltyID, categoryId, dataPost, callback) {
            API.patch('/loyalty/' + loyaltyID + '/card_categories/' + categoryId, dataPost, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryId
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.RemoveImageCardCategories = function (loyaltyID, categoryId, callback) {
            API.del('/loyalty/' + loyaltyID + '/card_categories/' + categoryId + '/image', function (success, data) {
                if (success) {
                    NotifyService.Success(data.message, false);
                }
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryId
         * @param dataPost
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UploadImageCardCategories = function (loyaltyID, categoryId, dataPost, callback) {
            API.postImage('/loyalty/' + loyaltyID + '/card_categories/' + categoryId + '/image', dataPost, function (success, data) {
                if (success) {
                    NotifyService.Success(data.message, false);
                }
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCardCategoriesSettings = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/card_categories_settings', function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param postData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.SaveCardCategoriesSettings = function (loyaltyID, postData, callback) {
            API.patch('/loyalty/' + loyaltyID + '/card_categories_settings', postData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCardCategoriesRules = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/card_categories_rules', function (success, data) {
                callback(success, data);
            });
        };


        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleId - Rule ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCardCategoriesRule = function (loyaltyID, ruleId, callback) {
            API.get('/loyalty/' + loyaltyID + '/card_categories_rules/' + ruleId, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleId
         * @param postData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.SaveCardCategoriesRule = function (loyaltyID, ruleId, postData, callback) {
            API.patch('/loyalty/' + loyaltyID + '/card_categories_rules/' + ruleId, postData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param postData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.SaveCardCategoriesRules = function (loyaltyID, postData, callback) {
            API.patch('/loyalty/' + loyaltyID + '/card_categories_rules', postData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param postData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddCardCategoriesRules = function (loyaltyID, postData, callback) {
            API.post('/loyalty/' + loyaltyID + '/card_categories_rules', postData, function (success, data) {
                callback(success, data);
            });
        };

        // =========================================  Loyalty Category Account price options  ===================================================

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param accountID - Account ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCategorySpecialAccountPriceOptions = function (loyaltyID, categoryID, accountID, callback) {
            API.get(`/loyalty/${loyaltyID}/card_categories/${categoryID}/special_accounts/${accountID}/price_options`, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param accountID - Account ID
         * @param postData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddCategorySpecialAccountPriceOption = function (loyaltyID, categoryID, accountID, postData, callback) {
            API.post(`/loyalty/${loyaltyID}/card_categories/${categoryID}/special_accounts/${accountID}/price_options`, postData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param accountID - Account ID
         * @param optionId - Price Option ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCategorySpecialAccountPriceOptionById = function (loyaltyID, categoryID, accountID, optionId, callback) {
            API.get(`/loyalty/${loyaltyID}/card_categories/${categoryID}/special_accounts/${accountID}/price_options//${optionId}`, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Delete/Clear loyalty photo.
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param accountID - Account ID
         * @param optionId - Price Option ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeleteCategorySpecialAccountPriceOption = function (loyaltyID, categoryID, accountID, optionId, callback) {
            API.delete(`/loyalty/${loyaltyID}/card_categories/${categoryID}/special_accounts/${accountID}/price_options/${optionId}`, null, function (success, response) {
                callback(success, response);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param accountID - Account ID
         * @param optionId - Price Option ID
         * @param postData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.SaveCategorySpecialAccountPriceOption = function (loyaltyID, categoryID, accountID, optionId, postData, callback) {
            API.patch(`/loyalty/${loyaltyID}/card_categories/${categoryID}/special_accounts/${accountID}/price_options/${optionId}`, postData, function (success, data) {
                callback(success, data);
            });
        };


        // =========================================  Loyalty Category Currency price options  ===================================================

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param currency - Currency
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCategoryCurrencyPriceOptions = function (loyaltyID, categoryID, currency, callback) {
            API.get(`/loyalty/${loyaltyID}/card_categories/${categoryID}/currencies/${currency}/price_options`, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param currency - Currency
         * @param postData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddCategoryCurrencyPriceOption = function (loyaltyID, categoryID, currency, postData, callback) {
            API.post(`/loyalty/${loyaltyID}/card_categories/${categoryID}/currencies/${currency}/price_options`, postData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param currency - Currency
         * @param optionId - Price Option ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetCategoryCurrencyPriceOptionById = function (loyaltyID, categoryID, currency, optionId, callback) {
            API.get(`/loyalty/${loyaltyID}/card_categories/${categoryID}/currencies/${currency}/price_options//${optionId}`, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Delete/Clear loyalty photo.
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param currency - Currency
         * @param optionId - Price Option ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeleteCategoryCurrencyPriceOption = function (loyaltyID, categoryID, currency, optionId, callback) {
            API.delete(`/loyalty/${loyaltyID}/card_categories/${categoryID}/currencies/${currency}/price_options/${optionId}`, null, function (success, response) {
                callback(success, response);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param categoryID - Category ID
         * @param currency - Currency
         * @param optionId - Price Option ID
         * @param postData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.SaveCategoryCurrencyPriceOption = function (loyaltyID, categoryID, currency, optionId, postData, callback) {
            API.patch(`/loyalty/${loyaltyID}/card_categories/${categoryID}/currencies/${currency}/price_options/${optionId}`, postData, function (success, data) {
                callback(success, data);
            });
        };


        // =========================================  Loyalty RULES  ===================================================

        /**
         * Get Rules of loyalty list.
         *
         * @param id - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyRules = function (id, callback) {

            API.get('/loyalty/' + id + '/rules', function (success, data) {
                callback(success, data);
            });

        };

        /**
         * Return loyalty rules settings
         *
         * @param {string} id - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetLoyaltyRulesSettings = function (id, callback) {
            API.get('/loyalty/' + id + '/rules/settings', function (success, data) {
                callback(success, data);
            });
        }
        /**
         * Modify loyalty rules settings
         *
         * @param {string} id - Loyalty ID
         * @param {object} post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UpdateLoyaltyRulesSettings = function (id, post_data, callback) {
            API.patch('/loyalty/' + id + '/rules/settings', post_data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Get Rule settings
         *
         * @param loyalty_id - Loyalty ID
         * @param id - Rule ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetLoyaltyRule = function (loyalty_id, id, callback) {
            API.get(`/loyalty/${loyalty_id}/rules/` + id, function (success, data) {

                callback(success, data);
            });
        };

        /**
         *
         * @param loyalty_id
         * @param id
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.ChangeLoyaltyRule = function (loyalty_id, id, post_data, callback) {
            API.patch(`/loyalty/${loyalty_id}/rules/` + id, post_data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyalty_id
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CreateLoyaltyRule = function (loyalty_id, post_data, callback) {
            API.post(`/loyalty/${loyalty_id}/rules`, post_data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.RulesSaveOrder = function (loyaltyID, post_data, callback) {
            API.patch('/loyalty/{0}/rules'.format(loyaltyID), post_data, function (success, data) {
                callback(success, data);
            });
        };

        // =========================================  Loyalty SETTINGS  ================================================

        /**
         * Get Loyalty settings
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltySettings = function (loyaltyID, callback) {
            if (!$rootScope.LOYALTY_SETTINGS)
                $rootScope.LOYALTY_SETTINGS = [];

            if ($rootScope.LOYALTY_SETTINGS[loyaltyID]) {
                callback(true, $rootScope.LOYALTY_SETTINGS[loyaltyID]);
            } else {
                API.get('/loyalty/{0}/settings'.format(loyaltyID), function (success, data) {
                    if (success) {
                        $rootScope.LOYALTY_SETTINGS[loyaltyID] = data;
                    }
                    callback(success, data);
                });
            }
        };

        /**
         * Set Loyalty settings
         *
         * @param loyaltyID - Loyalty ID
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltySettingsEdit = function (loyaltyID, post_data, callback) {
            if (!$rootScope.LOYALTY_SETTINGS)
                $rootScope.LOYALTY_SETTINGS = [];

            API.patch('/loyalty/{0}/settings'.format(loyaltyID), post_data, function (success, data) {
                if (success) {
                    $rootScope.LOYALTY_SETTINGS[loyaltyID] = data;
                }
                callback(success, data);
            });
        };

        // =====================================  Loyalty Referral Program  ============================================

        /**
         * Get Loyalty Referral Program
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyReferralProgram = function (loyaltyID, callback) {
            if (!$rootScope.LOYALTY_REFERRAL_PROGRAM)
                $rootScope.LOYALTY_REFERRAL_PROGRAM = [];

            if ($rootScope.LOYALTY_REFERRAL_PROGRAM[loyaltyID]) {
                callback(true, $rootScope.LOYALTY_REFERRAL_PROGRAM[loyaltyID]);
            } else {
                API.get('/loyalty/{0}/referral_program'.format(loyaltyID), function (success, data) {
                    if (success) {
                        $rootScope.LOYALTY_REFERRAL_PROGRAM[loyaltyID] = data;
                    }
                    callback(success, data);
                });
            }
        };

        /**
         * Set Loyalty Referral Program
         *
         * @param loyaltyID - Loyalty ID
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyReferralProgramEdit = function (loyaltyID, post_data, callback) {
            if (!$rootScope.LOYALTY_REFERRAL_PROGRAM)
                $rootScope.LOYALTY_REFERRAL_PROGRAM = [];

            API.patch('/loyalty/{0}/referral_program'.format(loyaltyID), post_data, function (success, data) {
                console.log(44444, data)
                if (success) {
                    $rootScope.LOYALTY_REFERRAL_PROGRAM[loyaltyID] = data;
                }
                callback(success, data);
            });
        };

        // =======================================  Loyalty Online Store  ==============================================

        /**
         * Get Loyalty Online Store
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyOnlineStore = function (loyaltyID, callback) {
            if (!$rootScope.LOYALTY_ONLINE_STORE)
                $rootScope.LOYALTY_ONLINE_STORE = [];

            if ($rootScope.LOYALTY_ONLINE_STORE[loyaltyID]) {
                callback(true, $rootScope.LOYALTY_ONLINE_STORE[loyaltyID]);
            } else {
                API.get('/loyalty/{0}/online_store'.format(loyaltyID), function (success, data) {
                    if (success) {
                        $rootScope.LOYALTY_ONLINE_STORE[loyaltyID] = data;
                    }
                    callback(success, data);
                });
            }
        };

        /**
         * Set Loyalty Online Store
         *
         * @param loyaltyID - Loyalty ID
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyOnlineStoreEdit = function (loyaltyID, post_data, callback) {
            if (!$rootScope.LOYALTY_ONLINE_STORE)
                $rootScope.LOYALTY_ONLINE_STORE = [];

            API.patch('/loyalty/{0}/online_store'.format(loyaltyID), post_data, function (success, data) {
                if (success) {
                    $rootScope.LOYALTY_ONLINE_STORE[loyaltyID] = data;
                }
                callback(success, data);
            });
        };

        /**
         * Get loyalty deliveries list.
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeliveryTypes = function (loyaltyID, callback) {
            if (!$rootScope.DELIVERY_TYPES)
                $rootScope.DELIVERY_TYPES = [];

            if ($rootScope.DELIVERY_TYPES[loyaltyID]) {
                callback(true, $rootScope.DELIVERY_TYPES[loyaltyID]);
            } else {
                API.get('/loyalty/' + loyaltyID + '/deliveries', function (success, data) {
                    if (success) {
                        $rootScope.DELIVERY_TYPES[loyaltyID] = data;
                    }
                    callback(success, $rootScope.DELIVERY_TYPES[loyaltyID]);
                });
            }
        };

        /**
         *
         * @param id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetDelivery = function (id, callback) {
            API.get('/loyalty/delivery/' + id, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.DELIVERY_TYPES[data.loyalty_id], data);
                }
                callback(success, data);
            });
        };


        /**
         *
         * @param id
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.ChangeDeliveryType = function (id, post_data, callback) {
            API.patch('/loyalty/delivery/' + id, post_data, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.DELIVERY_TYPES[data.loyalty_id], data);
                }
                callback(success, data);
            });
        };

        /**
         *
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CreateDeliveryType = function (post_data, callback) {
            API.post('/loyalty/delivery', post_data, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.DELIVERY_TYPES[data.loyalty_id], data);
                }
                callback(success, data);
            });
        };

        // =======================================  PKPASS settings  =================================================

        /**
         *
         * @param loyaltyID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetPkpassSettings = function (loyaltyID, callback) {
            API.get(`/loyalty/${loyaltyID}/pkpass/settings`, function (success, data) {
                callback(success, data);
            });
        };


        /**
         *
         * @param loyaltyID
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.ChangePkpassSettings = function (loyaltyID, post_data, callback) {
            API.patch(`/loyalty/${loyaltyID}/pkpass/settings`, post_data, function (success, data) {
                callback(success, data);
            });
        };

        // =======================================  Loyalty delivery services and Commissions  =================================================

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeliveryServicesTypes = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/additional_services', function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param service_id
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeliveryServiceById = function (service_id, loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/additional_services/' + service_id, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param service_id
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.removeDeliveryServiceById = function (service_id, loyaltyID, callback) {
            API.del('/loyalty/' + loyaltyID + '/additional_services/' + service_id, function (success, data) {

                callback(success, data);
            });
        };

        /**
         *
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CreateDeliveryServiceType = function (post_data, callback) {
            API.post('/loyalty/' + post_data.loyalty_id + '/additional_services', post_data, function (success, data) {

                callback(success, data);
            });
        };

        /**
         *
         * @param post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.ChangeDeliveryService = function (post_data, callback) {
            API.patch('/loyalty/' + post_data.loyalty_id + '/additional_services/' + post_data.id, post_data, function (success, data) {

                callback(success, data);
            });
        };

        // =======================================  Loyalty Message Templates  =================================================

        /**
         * Get Message groups
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getMessageGroups = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/customers_messages_groups', function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Get Message settings
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getMessageSettings = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/customers_messages_values', function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Get Loyalty Message Templates
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyMessageTemplates = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/customers_messages', function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Update Loyalty Message Templates
         * @param messageTemplate - messageTemplate data array. Got array but works correct only with single value
         */
        service.updateMessageTemplates = function (loyaltyID, messageTemplate, callback) {
            API.patch('/loyalty/' + loyaltyID + '/customers_messages', messageTemplate, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param messageTemplate
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyMessageTemplatesTest = function (loyaltyID, messageTemplate, callback) {
            API.post('/loyalty/' + loyaltyID + '/customers_messages/template_test', messageTemplate, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetTaxes = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/taxes', function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param taxID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetTax = function (loyaltyID, taxID, callback) {
            API.get('/loyalty/' + loyaltyID + '/taxes/' + taxID, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param tax
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddTax = function (loyaltyID, tax, callback) {
            API.post('/loyalty/' + loyaltyID + '/taxes', tax, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param taxID
         * @param tax
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.EditTax = function (loyaltyID, taxID, tax, callback) {
            API.patch('/loyalty/' + loyaltyID + '/taxes/' + taxID, tax, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param taxID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeleteTax = function (loyaltyID, taxID, callback) {
            API.del('/loyalty/' + loyaltyID + '/taxes/' + taxID, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetTaxesSummary = function (loyaltyID, params, callback) {
            API.get(`/loyalty/${loyaltyID}/taxes/summary?{0}`.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetTaxesSummaryItems = function (loyaltyID, params, callback) {
            API.get(`/loyalty/${loyaltyID}/taxes/summary/items?{0}`.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetAdditionalCosts = function (loyaltyID, callback) {
            API.get('/loyalty/' + loyaltyID + '/additional_costs', function (success, data) {
                callback(success, data);
            });
        };
        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param additionalCosts
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddAdditionalCosts = function (loyaltyID, additionalCosts, callback) {
            API.post('/loyalty/' + loyaltyID + '/additional_costs', additionalCosts, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param additionalCostID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetAdditionalCost = function (loyaltyID, additionalCostID, callback) {
            API.get('/loyalty/' + loyaltyID + '/additional_costs/' + additionalCostID, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param additionalCostID
         * @param additionalCosts
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.EditAdditionalCosts = function (loyaltyID, additionalCostID, additionalCosts, callback) {
            API.patch('/loyalty/' + loyaltyID + '/additional_costs/' + additionalCostID, additionalCosts, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param additionalCostID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeleteAdditionalCosts = function (loyaltyID, additionalCostID, callback) {
            API.del('/loyalty/' + loyaltyID + '/additional_costs/' + additionalCostID, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetAdditionalCostsSummary = function (loyaltyID, params, callback) {
            API.get(`/loyalty/${loyaltyID}/additional_costs/summary?{0}`.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetAdditionalCostsSummaryItems = function (loyaltyID, params, callback) {
            API.get(`/loyalty/${loyaltyID}/additional_costs/summary/items?{0}`.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                callback(success, data);
            });
        };

        // =======================================  Loyalty External Forms Templates  =================================================

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param params - Request query
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalFormsRules = function (loyaltyID, params, callback) {
            API.get(`/loyalty/${loyaltyID}/external_forms/rules`.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                callback(success, data);
            });
        }


        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param data - Request data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddExternalFormsRule = function (loyaltyID, data, callback) {
            API.post(`/loyalty/${loyaltyID}/external_forms/rules`, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleID - Rule ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalFormsRuleById = function (loyaltyID, ruleID, callback) {
            API.get(`/loyalty/${loyaltyID}/external_forms/rules/${ruleID}`, function (success, data) {
                callback(success, data);
            });
        }

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleID - Rule ID
         * @param data - Request data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UpdateExternalFormsRuleById = function (loyaltyID, ruleID, data, callback) {
            API.patch(`/loyalty/${loyaltyID}/external_forms/rules/${ruleID}`, data, function (success, data) {
                callback(success, data);
            });
        }

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleID - Rule ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeleteExternalFormsRuleById = function (loyaltyID, ruleID, callback) {
            API.del(`/loyalty/${loyaltyID}/external_forms/rules/${ruleID}`, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleID - Rule ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalFormsRuleConditions = function (loyaltyID, ruleID, callback) {
            API.get(`/loyalty/${loyaltyID}/external_forms/rules/${ruleID}/conditions`, function (success, data) {
                callback(success, data);
            });
        }

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleID - Rule ID
         * @param data - Request data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddExternalFormsRuleCondition = function (loyaltyID, ruleID, data, callback) {
            API.post(`/loyalty/${loyaltyID}/external_forms/rules/${ruleID}/conditions`, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleID - Rule ID
         * @param conditionID - Condition ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeleteExternalFormsRuleConditionById = function (loyaltyID, ruleID, conditionID, callback) {
            API.del(`/loyalty/${loyaltyID}/external_forms/rules/${ruleID}/conditions/${conditionID}`, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleID - Rule ID
         * @param conditionID - Condition ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalFormsRuleConditionById = function (loyaltyID, ruleID, conditionID, callback) {
            API.get(`/loyalty/${loyaltyID}/external_forms/rules/${ruleID}/conditions/${conditionID}`, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param loyaltyID - Loyalty ID
         * @param ruleID - Rule ID
         * @param conditionID - Condition ID
         * @param data - Request data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UpdateExternalFormsRuleConditionById = function (loyaltyID, ruleID, conditionID, data, callback) {
            API.patch(`/loyalty/${loyaltyID}/external_forms/rules/${ruleID}/conditions/${conditionID}`, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Upload ReferralLogo
         * @param loyaltyID - Loyalty ID
         * @param data
         * @param {requestCallback} callback - The callback that handles the response.
         *
         */
        service.UploadReferralLogo = function (loyaltyID, data, callback) {
            API.postImage('/loyalty/' + loyaltyID + '/referral_program/referral_logo', data, function (success, response) {
                if (success) {
                    $rootScope.LOYALTY_REFERRAL_PROGRAM[loyaltyID] = response;
                }
                callback(success, response);
            });
        };

        /**
         * Delete/Clear loyalty ReferralLogo.
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeleteReferralLogo = function (loyaltyID, callback) {
            API.delete('/loyalty/' + loyaltyID + '/referral_program/referral_logo', null, function (success, response) {
                if (success) {
                    $rootScope.LOYALTY_REFERRAL_PROGRAM[loyaltyID] = response;
                }
                callback(success, response);
            });
        };

        /**
         * Upload ReferralLogo
         * @param loyaltyID - Loyalty ID
         * @param data
         * @param {requestCallback} callback - The callback that handles the response.
         *
         */
        service.UploadReferrerLogo = function (loyaltyID, data, callback) {
            API.postImage('/loyalty/' + loyaltyID + '/referral_program/referrer_logo', data, function (success, response) {
                if (success) {
                    $rootScope.LOYALTY_REFERRAL_PROGRAM[loyaltyID] = response;
                }
                callback(success, response);
            });
        };

        /**
         * Delete/Clear loyalty ReferralLogo.
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.DeleteReferrerLogo = function (loyaltyID, callback) {
            API.delete('/loyalty/' + loyaltyID + '/referral_program/referrer_logo', null, function (success, response) {
                if (success) {
                    $rootScope.LOYALTY_REFERRAL_PROGRAM[loyaltyID] = response;
                }
                callback(success, response);
            });
        };


        // External access

        /**
         * Get loyalty data access list
         *
         * @param loyaltyID - Loyalty ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalAccessList = function (loyaltyID, callback) {
            API.get(`/loyalty/${loyaltyID}/external_data_access`, function (success, data) {
                callback(success, data);
            });
        }

        /**
         * Get loyalty data access
         *
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalAccessScope = function (callback) {
            var url = '/external_data_access/scopes?object_type=loyalty';
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Add loyalty data access
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {Object} data - Loyalty data access
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddExternalAccess = function (loyaltyId, data, callback) {
            var url = '/loyalty/{0}/external_data_access'.format(loyaltyId);
            API.post(url, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Delete loyalty data access
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} accessId - Access ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.RemoveExternalAccess = function (loyaltyId, accessId, callback) {
            var url = '/loyalty/{0}/external_data_access/{1}'.format(loyaltyId, accessId);
            API.del(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return loyalty data access
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} accessId - Access ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalAccess = function (loyaltyId, accessId, callback) {
            var url = '/loyalty/{0}/external_data_access/{1}'.format(loyaltyId, accessId);
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Update loyalty data access
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} accessId - Access ID
         * @param {Object} data - Loyalty data access
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UpdateExternalAccess = function (loyaltyId, accessId, data, callback) {
            var url = '/loyalty/{0}/external_data_access/{1}'.format(loyaltyId, accessId);
            API.patch(url, data, function (success, data) {
                callback(success, data);
            });
        };

        return service;
    }

})();
